import { normalize, denormalize } from 'normalizr';
import * as schema from './schema';
// TODO: how to convert this into a fragment, what does a fragment
// look like with multiple roots
export function normalizeItems(data) {
    var _a = normalize(data, schema.itemArray), result = _a.result, entities = _a.entities;
    return { result: result, items: entities.items };
}
export function normalizeCanvas(data) {
    var _a = normalize(data, schema.design), result = _a.result, entities = _a.entities;
    return { root: result, items: entities.items || {} };
}
export function denormalizeItem(normalizedItem, entities) {
    return denormalize(normalizedItem, schema.item, entities);
}
export function denormalizeItems(normalizedItems, entities) {
    return denormalize(normalizedItems, schema.itemArray, entities);
}
export function denormalizeCanvas(d) {
    return denormalize(d.root, schema.design, d);
}
